import React, { useState, useEffect, useCallback } from "react";
import ModalB from "react-bootstrap/Modal";
import "./modal.css";
import api from "../../services/axios";
import Loading from "../../assets/home/loading.gif";
import {
  FaBuilding,
  FaStar,
  FaThumbsUp,
  FaCheck,
  FaTimes,
  FaClock,
} from "react-icons/fa";

function normalizarStatus(status) {
  const valor = String(status || "")
    .trim()
    .toLowerCase();
  if (valor === "confirmado") return "confirmado";
  if (valor === "recusado") return "recusado";
  return "pendente";
}

function labelStatus(status) {
  if (status === "confirmado") return "Confirmado";
  if (status === "recusado") return "Recusado";
  return "Pendente";
}

function labelTipo(tipo) {
  if (tipo === "mais_quero") return "Prioritário";
  if (tipo === "quero") return "Desejável";
  return tipo || "—";
}

const ModalPatrocinadoresEscolheramParticipante = ({
  show,
  toggleModal,
  titulo,
  userId,
  nomeParticipante,
}) => {
  const [escolhas, setEscolhas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const carregarEscolhas = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError("");
    try {
      const response = await api.get(
        `/participante-patrocinadores-escolha/${userId}`,
      );
      if (response.status === 200) {
        setEscolhas(
          Array.isArray(response.data?.dados) ? response.data.dados : [],
        );
      }
    } catch (err) {
      console.error("Erro ao carregar patrocinadores:", err);
      setError(
        err?.response?.data?.mensagem ||
          "Erro ao carregar patrocinadores que escolheram o participante",
      );
      setEscolhas([]);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (show && userId) {
      carregarEscolhas();
    }
  }, [show, userId, carregarEscolhas]);

  const handleModal = () => {
    setEscolhas([]);
    setError("");
    toggleModal();
  };

  const prioritarias = escolhas.filter((e) => e.tipo === "mais_quero");
  const desejaveis = escolhas.filter((e) => e.tipo === "quero");

  const renderLista = (lista, tituloLista, icone, corTema) => {
    const listaOrdenada = [...lista].sort(
      (a, b) => Number(a.sequencia || 0) - Number(b.sequencia || 0),
    );

    return (
      <div className="lista-escolhas">
        <div
          className="header-lista-escolhas"
          style={{ backgroundColor: corTema }}
        >
          <div className="titulo-lista">
            {icone}
            <h6>{tituloLista}</h6>
            <span className="contador">({listaOrdenada.length})</span>
          </div>
        </div>
        <div className="body-lista-escolhas">
          {listaOrdenada.length > 0 ? (
            listaOrdenada.map((escolha) => {
              const status = normalizarStatus(escolha.status);
              const nome =
                escolha.patrocinador?.nome || "Patrocinador não informado";
              return (
                <div
                  key={
                    escolha.id ||
                    `${escolha.id_patrocinador}-${escolha.tipo}-${escolha.sequencia}`
                  }
                  className={`item-escolha item-escolha--${status}`}
                >
                  <div className="info-usuario">
                    <div className="nome-usuario">
                      {escolha.sequencia ? (
                        <span className="seq-escolha">
                          {escolha.sequencia}º
                        </span>
                      ) : (
                        <FaBuilding className="icone-usuario" />
                      )}
                      {nome}
                    </div>
                    {escolha.patrocinador?.segmento ? (
                      <div className="empresa-usuario">
                        <FaBuilding className="icone-empresa" />
                        {escolha.patrocinador.segmento}
                      </div>
                    ) : null}
                  </div>
                  <div
                    className={`status-escolha status-escolha--${status}`}
                    title={`Status: ${labelStatus(status)} · ${labelTipo(escolha.tipo)}`}
                  >
                    {status === "confirmado" ? (
                      <FaCheck aria-hidden />
                    ) : status === "recusado" ? (
                      <FaTimes aria-hidden />
                    ) : (
                      <FaClock aria-hidden />
                    )}
                    <span>{labelStatus(status)}</span>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="lista-vazia">
              <p>Nenhuma escolha {tituloLista.toLowerCase()}</p>
            </div>
          )}
        </div>
      </div>
    );
  };

  const tituloModal =
    titulo ||
    (nomeParticipante
      ? `Patrocinadores que escolheram ${nomeParticipante}`
      : "Patrocinadores que escolheram o participante");

  return (
    <ModalB show={show} onHide={handleModal} size="lg">
      <ModalB.Header closeButton>
        <ModalB.Title className="titulo-modal">{tituloModal}</ModalB.Title>
      </ModalB.Header>
      <ModalB.Body>
        {loading ? (
          <div className="area-loading-blur">
            <div className="area-loading">
              <img src={Loading} alt="Carregando..." />
            </div>
          </div>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : (
          <div className="container-escolhas">
            <div className="row">
              <div className="col-md-6">
                {renderLista(
                  prioritarias,
                  "Prioritário",
                  <FaStar className="icone-lista" />,
                  "#6c757d",
                )}
              </div>
              <div className="col-md-6">
                {renderLista(
                  desejaveis,
                  "Desejável",
                  <FaThumbsUp className="icone-lista" />,
                  "#17a2b8",
                )}
              </div>
            </div>
            {escolhas.length === 0 && !loading ? (
              <div className="sem-escolhas">
                <div className="alert alert-info text-center">
                  <h5>Nenhum patrocinador encontrado</h5>
                  <p>
                    Nenhum patrocinador escolheu este participante ainda.
                  </p>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </ModalB.Body>
    </ModalB>
  );
};

export default ModalPatrocinadoresEscolheramParticipante;
